import ViewHOCAction from './Component';

export default ViewHOCAction;